export const setupTOTP = {
    QR: {
        totpIssuer: 'Webgains Platform',
    },
}

export default setupTOTP
